module.exports = __webpack_public_path__ + "img/zbbs-icon.a9bccb8.svg";